const InputRadioField = ({
  register = () => {},
  errors = {},
  checked,
  watch,
  setValue = () => {},
  viewOnly = false,
  className = "",
  labelName = "Active",
  yesNo = false,
  delivary_status = false,
  disabled = false,
}) => {
 
  const fieldKey = delivary_status ? "delivarable" : "active";
  const activeValue = viewOnly ? "" : watch(fieldKey);
  return (
    <>
      <label className="form-label title mb-2" style={{ color: "#4B4853" }}>
        {viewOnly ? (delivary_status ? "Delivarable" : "Acctive") : labelName}
        <span className="star">*</span>
      </label>

      <div className="d-flex">
        <div className="form-check form-check-inline me-3 align-items-center">
          {viewOnly ? (
            <input
              className="form-check-input me-3"
              type="radio"
              name={fieldKey}
              id={`${fieldKey}-yes`}
              value="true"
              checked={checked === true || checked === "true"}
              disabled
            />
          ) : (
            <input
              className="form-check-input me-3"
              type="radio"
              name={fieldKey}
              id={`${fieldKey}-yes`}
              {...register(fieldKey, { required: true })}
              value="true"
              checked={activeValue === true || activeValue === "true"}
              onChange={() => setValue(fieldKey, true)}
              disabled={disabled}
            />
          )}
          <label htmlFor={`${fieldKey}-yes`} className="text-dark">
            {viewOnly || yesNo
              ? "Yes"
              : delivary_status
                ? "Delivarable"
                : "Active"}
          </label>
        </div>

        <div className="form-check form-check-inline align-items-center">
          {viewOnly ? (
            <input
              className="form-check-input me-3"
              type="radio"
              name={fieldKey}
              id={`${fieldKey}-no`}
              value="false"
              checked={checked === false || checked === "false"}
              disabled
            />
          ) : (
            <input
              className="form-check-input me-3"
              type="radio"
              name={fieldKey}
              id={`${fieldKey}-no`}
              {...register(fieldKey, { required: true })}
              value="false"
              checked={activeValue === false || activeValue === "false"}
              onChange={() => setValue(fieldKey, false)}
              disabled={disabled}
            />
          )}
          <label htmlFor={`${fieldKey}-no`} className="text-dark">
            {viewOnly || yesNo
              ? "No"
              : delivary_status
                ? "Not Delivarable"
                : "Inactive"}
          </label>
        </div>
      </div>

      {errors.active && (activeValue === null || activeValue === undefined) && (
        <div className={`invalid-feedback d-block`}>
          Please select an Option
        </div>
      )}
    </>
  );
};

export default InputRadioField;
